import React, { createContext, useContext, useState, ReactNode } from 'react';

interface AnimationContextType {
  isTransitioning: boolean;
  direction: 'left' | 'right' | null;
  startTransition: (direction: 'left' | 'right') => void;
  endTransition: () => void;
}

const AnimationContext = createContext<AnimationContextType | undefined>(undefined);

export const useAnimation = () => {
  const context = useContext(AnimationContext);
  if (context === undefined) {
    throw new Error('useAnimation must be used within an AnimationProvider');
  }
  return context;
};

interface AnimationProviderProps {
  children: ReactNode;
}

export const AnimationProvider: React.FC<AnimationProviderProps> = ({ children }) => {
  const [isTransitioning, setIsTransitioning] = useState(false);
  const [direction, setDirection] = useState<'left' | 'right' | null>(null);

  const startTransition = (newDirection: 'left' | 'right') => {
    setDirection(newDirection);
    setIsTransitioning(true);
  };

  const endTransition = () => {
    setIsTransitioning(false);
    setDirection(null);
  };

  return (
    <AnimationContext.Provider value={{
      isTransitioning,
      direction,
      startTransition,
      endTransition,
    }}>
      {children}
    </AnimationContext.Provider>
  );
}; 